import { useContext, createContext, ReactNode } from "react";
import { useHistory } from "react-router";

export type History = ReturnType<typeof useHistory>;
const context = createContext<History | null>(null);

export function Provider({ children }: { children: ReactNode }) {
  const history = useHistory();

  return <context.Provider value={history}>{children}</context.Provider>;
}

export default function useRootHistory() {
  return useContext(context)!;
}
